<p-card header="Email Template">
	<div class="d-flex">
		<div class="d-flex m-2">
			<p-button pRipple styleClass="p-button-raised m-2" (click)="emailTemplateNew()">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
		<div class="d-flex m-2 flex-grow-1">
			<p-dropdown
				placeholder="Select Email Template..."
				[disabled]="!editorIsLoaded"
				[options]="emailTemplateList"
				optionLabel="name"
				name="sourceList"
				[(ngModel)]="emailTemplateSelected"
				[virtualScroll]="true"
				[virtualScrollItemSize]="31"
				[filter]="true"
				filterBy="name"
				[style]="{ width: '100%' }"
				styleClass="m-2"
				appendTo="body"
				(onChange)="loadSelectedTemplate(emailTemplateSelected)"
			></p-dropdown>
		</div>

		<div class="my-2 me-2 ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-danger m-2" [disabled]="!emailTemplateSelected" (click)="clearDesign()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center"><fa-icon [icon]="['far', 'times']" size="lg" class="ms-1 me-2"></fa-icon> Clear Template</div>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass="p-button-raised p-button-success m-2" [disabled]="!emailTemplateSelected" (click)="save()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center"><fa-icon [icon]="['far', 'save']" size="lg" class="ms-1 me-2"></fa-icon> Save Template</div>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" [disabled]="!emailTemplateSelected" (click)="exportHtml()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'file-export']" size="lg" class="ms-1 me-2"></fa-icon> Export to HTML
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<div>
		<span class="p-float-label m-2" *ngIf="emailTemplateSelected">
			<input pInputText type="text" id="templateName" name="templateName" [(ngModel)]="emailTemplateSelected.name" class="w-100" />
			<label for="templateName">Email Template Name</label>
		</span>
	</div>
	<div class="container">
		<email-editor #editor editorId="editor" (loaded)="editorLoaded($event)"></email-editor>
	</div>
</p-card>
